import React from 'react';
import { TargetListItem } from '../TargetListItem/TargetListItem';

export function TargetListCardItem({ data }) {
  return <TargetListItem target={data} />;
}
